import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=c97240d4&"
import script from "./Brands.ts?vue&type=script&lang=ts&"
export * from "./Brands.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports